import { useEffect, useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "./Gyms.css";

function Gyms() {
  const firstnameRef = useRef<HTMLInputElement>(null);
  const lastnameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const gymRef = useRef<HTMLInputElement>(null);
  const addressRef = useRef<HTMLInputElement>(null);
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  useEffect(() => emailjs.init("Rhf5d7xW7RUdYldG2"), []);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const serviceId = "service_mindsets";
    const templateId = "template_emq5ytr";

    try {
      setLoading(true);
      await emailjs.send(serviceId, templateId, {
        firstname: firstnameRef.current?.value,
        lastname: lastnameRef.current?.value,
        email: emailRef.current?.value,
        gym: gymRef.current?.value,
        address: addressRef.current?.value,
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setEmailSent(true);
    }
  };

  return (
    <div className="gyms">
      <Header />
      <div className="other-image"></div>
      <div className="page">
        <h1>Gyms</h1>
        <h3>Gym Sign-up</h3>
        <h2>Enter your details here</h2>
        <p>
          Help your members get even stronger by signing your gym up for
          MindSets. We have a limited number of packs still available, so
          register your interest below and we’ll aim to get a pack out to you.
        </p>
        {emailSent ? (
          <div className="complete">
            <p>Your form has been successfully submitted. Thanks for getting in touch.</p>
          </div>
        ) : (
          <form className="form" onSubmit={handleSubmit}>
            <label htmlFor="firstName">First name</label>
            <input
              ref={firstnameRef}
              type="text"
              id="firstName"
              name="firstName"
              placeholder="First name"
            ></input>
            <label htmlFor="lastName">Last name</label>
            <input
              ref={lastnameRef}
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Last name"
            ></input>
            <label htmlFor="email">Email</label>
            <input
              ref={emailRef}
              type="email"
              id="email"
              name="email"
              placeholder="Email address"
            ></input>
            <label htmlFor="gym">What gym are you representing?</label>
            <input
              ref={gymRef}
              type="text"
              id="gym"
              name="gym"
              placeholder=""
            ></input>
            <label htmlFor="address">Gym address/location</label>
            <input
              ref={addressRef}
              type="text"
              id="address"
              name="address"
              placeholder=""
            ></input>
            <button className="button" type="submit">
              <span>Sign Up Now</span>
            </button>
          </form>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default Gyms;
